import "./style.scss";
const CustomInput = ({
  label,
  onChanged,
  error,
  style,
  value,
  showError = false,
  type = "text",
}: {
  showError?: boolean;
  type?: string;
  style?: any;
  label: string;
  onChanged?: (value: any) => void;
  error?: string;
  value?: any;
}) => {
  return (
    <div style={{ marginBlockEnd: 10 }}>
      <div className="form-floating">
        <input
          type={type}
          className="form-control"
          id={label}
          value={value}
          style={style}
          placeholder={label}
          onChange={(e) => onChanged && onChanged(e.target.value)}
        />
        <label className={error ? "color-red" : ""} htmlFor={label}>
          {label}{" "}
        </label>
      </div>
      {showError && error && (
        <span style={{ color: "red", fontSize: "10px" }}>*{error}</span>
      )}
    </div>
  );
};
export default CustomInput;
